import * as yup from 'yup';

export const AddStorageLotSchema = yup.object({
  lot_id: yup.string().required('Lot is required'),
  lot_number: yup.string().required('Lot number is required'),
  date_of_storage: yup.date().required('Date of storage is required').typeError('Invalid date'),

  moisture_1: yup
    .number()
    .required('Moisture 1 is required')
    .typeError('Moisture 1 must be a number')
    .min(0, 'Must be greater than or equal to 0')
    .max(100, 'Must be less than or equal to 100'),

  moisture_2: yup
    .number()
    .nullable()
    .typeError('Moisture 2 must be a number')
    .min(0, 'Must be greater than or equal to 0')
    .max(100, 'Must be less than or equal to 100'),

  bags: yup
    .number()
    .required('Bags is required')
    .nullable()
    .typeError('Bags must be a number')
    .integer('Bags must be a whole number')
    .min(0, 'Cannot be negative'),

  //   total_weight_kg: yup.number().nullable().typeError('Total weight must be a number').min(0, 'Cannot be negative'),
  total_weight: yup
    .mixed()
    .required('Total weight is required')
    .optional()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : originalValue))
    .test('is-number', 'Total weight must be a number', value => value === null || !isNaN(value))
    .test('max-2-decimals', 'Total weight can have at most 2 decimal places', value => {
      if (value === null || value === undefined) return true;

      const str = value.toString();

      // allows: 9 | 9.8 | 9.88 | .5 | .56
      return /^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(str);
    })
    .test('positive', 'Total weight must be greater than 0', value => value === null || Number(value) > 0),

  comments: yup.string().nullable().max(500, 'Comments cannot exceed 500 characters'),
});

export const RecordConsumptionSchema = yup.object({
  lot_id: yup.string().required('Lot is required'),
  storage_label: yup.string().required('Storage label is required'),
  date_of_consumption: yup.date().required('Date of consumption is required').typeError('Invalid date'),

  storage_lot_id: yup.string().required('Storage lot is required'),

  weight: yup
    .mixed()
    .required('Weight is required')
    .optional()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : originalValue))
    .test('is-number', 'Weight must be a number', value => value === null || !isNaN(value))
    .test('max-2-decimals', 'Weight can have at most 2 decimal places', value => {
      if (value === null || value === undefined) return true;

      const str = value.toString();

      // allows: 9 | 9.8 | 9.88 | .5 | .56
      return /^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(str);
    })
    .test('positive', 'Weight must be greater than 0', value => value === null || Number(value) > 0),
    
  // weight: yup
  //   .number()
  //   .required('Weight is required')
  //   .typeError('Weight must be a number')
  //   .integer('Weight must be a whole number')
  //   .min(0, 'Cannot be negative'),

  reason: yup.string().required('Reason is required').max(500, 'Reason for consumption cannot exceed 500 characters'),
});

export const UpdateConsumptionSchema = yup.object({
  id: yup.string().required('ID is required'),
  storage_label: yup.string().required('Storage label is required'),
  storage_lot_id: yup.string().required('Storage lot is required'),
  date_of_consumption: yup.date().required('Date of consumption is required').typeError('Invalid date'),
  weight: yup
    .mixed()
    .required('Weight is required')
    .optional()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : originalValue))
    .test('is-number', 'Weight must be a number', value => value === null || !isNaN(value))
    .test('max-2-decimals', 'Weight can have at most 2 decimal places', value => {
      if (value === null || value === undefined) return true;

      const str = value.toString();

      // allows: 9 | 9.8 | 9.88 | .5 | .56
      return /^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(str);
    })
    .test('positive', 'Weight must be greater than 0', value => value === null || Number(value) > 0),

  reason: yup.string().required('Reason is required').max(500, 'Reason for consumption cannot exceed 500 characters'),
});
